import i18n from '../../../i18n';
import {isEmpty, isInteger} from 'lodash';
import moment from 'moment'

export const validate = values => {
    let errors = {};

    date(values, errors);
    bikes(values, errors);
    from(values, errors);
    to(values, errors);

    return errors;
};

const date = (values, errors) => {
    if (isEmpty(values.date)) {
        return errors.date = i18n.t('booking.validation_date');
    }
    if (moment(values.date) <= moment()) {
        return errors.date = i18n.t('booking.validation_invalid_date');
    }
};

const from = (values, errors) => {
    if (!validateFromTo('from', values.from)) {
        errors.from = i18n.t('booking.validation_bag_transport_from');
    }
};

const to = (values, errors) => {
    if (!validateFromTo('to', values.to)) {
        errors.to = i18n.t('booking.validation_bag_transport_to');
    }
};

const bikes = (values, errors) => {

    if (!isInteger(values.bikes) || values.bikes <= 0) {
        return errors.bikes = i18n.t('booking.validation_bag_count_zero');
    }
};

const validateFromTo = (field, value) => {
    if(value) {
        const {firstInput, secondInput} = value;

        if (null == firstInput) {
            return false;
        }

        if ('stop' == firstInput.type) {
            return true;
        }

        if (null !== secondInput && 'stop' == secondInput.type) {
            return true;
        }
    }
    return false;
};

